import { NodeViewSettingsPanel } from '@/components/common/node-view-settings-panel';
import { CommonNodeViewWrapper } from '@/components/common/node-view-wrapper';
import { useIsEditorReadonly } from '@/hooks/use-is-editor-readonly';
import { dispatchMetaTransaction } from '@/lib/zy-tiptap-utils';
import type { ReactNodeViewProps } from '@tiptap/react';
import { NodeViewContent } from '@tiptap/react';
import { PlusIcon } from 'lucide-react';

export function ZyExerciseNodeView(props: ReactNodeViewProps) {
    const { node, selected, updateAttributes, editor, decorations } = props;
    const isEditorReadonly = useIsEditorReadonly(editor);
    const caption = node.attrs.caption;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        updateAttributes({ caption: e.target.value });
    };

    const handleAddZyProblem = () => {
        editor.commands.addZyProblem(node);
        dispatchMetaTransaction(editor, { zyExerciseUpdate: true });
    };

    return (
        <CommonNodeViewWrapper
            decorations={decorations}
            label="Exercise"
            selected={selected}
            settingsPanel={
                <NodeViewSettingsPanel
                    fields={[
                        {
                            label: 'Caption',
                            type: 'text',
                            value: caption,
                            onChange: handleChange,
                            placeholder: 'Caption...',
                            searchAttr: 'caption',
                        },
                    ]}
                />
            }
            footer={
                <button
                    onClick={handleAddZyProblem}
                    disabled={isEditorReadonly}
                    className="flex w-full items-center justify-center gap-2 rounded-lg border-2 border-gray-300 py-1 text-gray-500 transition-all duration-200 hover:border-blue-400 hover:bg-blue-50 hover:text-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none dark:border-gray-600 dark:text-gray-400 dark:hover:border-blue-500 dark:hover:bg-blue-950/20 dark:hover:text-blue-400 dark:focus:ring-offset-gray-900 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    <PlusIcon className="h-4 w-4" />
                    <span className="text-sm font-medium">Add Problem</span>
                </button>
            }
            fullscreenContent={<NodeViewContent />}
            fullscreenMode="inline"
            contentHeightClassName=""
        >
            <NodeViewContent />
        </CommonNodeViewWrapper>
    );
}
